<template>
<div class="Msg_container">
    <div class="container">
        <div class="type_box">
            <div class="row_box">
                <p class="title_text">企业名称</p>
                <van-field v-model="formData.name" placeholder="请填写正确的企业名称"></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">称呼</p>
                <van-field v-model="formData.linkman" placeholder="请填写您的称呼"></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">电话</p>
                <van-field v-model="formData.linktel" type="tel" maxlength="11" placeholder="请填写您的电话"></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">反馈问题</p>
                <van-field v-model="formData.content" type="textarea" rows="3" maxlength="120" show-word-limit placeholder="请将您的疑问记录下来。"></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">验证码</p>
                <van-field v-model="formData.usercode" maxlength="4" placeholder="请输入验证码"><template #button><img @click="getAuthCode" class="auth_code_img" :src="authCodeImg === '' ? require('@/common/images/gujingimgs/bg1.png') : authCodeImg" alt=""></template></van-field>
            </div>
        </div>
    </div>
    <div class="donwnload_pop_warp">
        <van-popup v-model="showPop" @close="closePop">
            <div class="donwnload_box">
                <img class="down_img" :src="require('@/common/images/gujingimgs/icon_other.png')" alt="">
                <p>您的留言提交成功，我们会<br />在最短时间与您联系！</p>
                <div @click="$router.go(-1)" class="btn">好的，知道了</div>
            </div>
        </van-popup>
    </div>
    <div @click="subMitBtn" :class="{'btn_box': true, 'disable_btn': false}">提交留言</div>
</div>
</template>

<script>
import {Toast} from 'vant'
import {createCode, operateGuestNoteByCode} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'Msg',
    data() {
        return {
            showPop: false, // 留言成功后提示弹窗
            formData: {
                code: 'A01',
                name: '',
                linkman: '',
                linktel: '',
                content: '',
                usercode: '',
                codeEncryption: '',
                clienttype: ''
            },
            authCodeImg: ''
        }
    },
    mounted() {
        this.getAuthCode()
    },
    methods: {
        // 获取验证码
        getAuthCode() {
            this.setLoading(true)
            let params = {}
            createCode({
                data: Object.assign({}, params),
                success: data => {
                    console.log(data)
                    this.setLoading(false)
                    this.authCodeImg = data.result.base64
                    this.formData.codeEncryption = data.result.codeEncryption
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 提交留言按钮
        subMitBtn() {
            if (this.formData.name === '') {
                Toast('请填写企业名称')
                return
            }
            if (this.formData.linkman === '') {
                Toast('请填写您的称呼')
                return
            }
            if (this.formData.linktel === '') {
                Toast('请填写您的电话')
                return
            }
            if (this.formData.content === '') {
                Toast('请填写您的疑问')
                return
            }
            if (this.formData.usercode === '') {
                Toast('请输入验证码')
                return
            }
            this.subMitMessage()
        },
        // 开始提交留言
        subMitMessage() {
            this.setLoading(true)
            let params = {}
            operateGuestNoteByCode({
                data: Object.assign({}, params, this.formData),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    if (data) {
                        this.showPop = true
                    }
                },
                error: data => {
                    this.$toast.fail(data.msg)
                    this.getAuthCode()
                }
            })
        },
        // 弹窗关闭
        closePop() {
            this.$router.go(-1)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.Msg_container {
    min-height: 100vh;
    background-color: #F5F7FA;
    padding: 0.4rem 0.32rem;
    padding-bottom: 1.2rem;
    box-sizing: border-box;
    .container {
        background-color: #fff;
        padding: 0.32rem;
        padding-top: 0rem;
        .type_box {
            .row_box {
                border-bottom: 0.01rem solid #E5E5E5;
                padding-top: 0.3rem;
                // padding-bottom: 0.12rem;
                padding-bottom: 0.1rem;
                .title_text {
                    color: #333;
                    font-size: 0.32rem;
                    line-height: 0.46rem;
                    // padding-bottom: 0.08rem;
                    padding-bottom: 0;
                    display: flex;
                    align-items: center;
                    &>img {
                        margin-left: 0.2rem;
                        width: 0.22rem;
                        height: 0.22rem;
                    }
                }
                .van-cell{
                    padding: 0.2rem 0;
                    font-size: 0.32rem;
                }
                .auth_code_img {
                    width: 1.6rem;
                    height: 0.68rem;
                }
            }
            .row_box:nth-last-of-type(1){
                border-bottom: none;
                padding-bottom: 0;
                .van-cell{
                    padding-bottom: 0;
                }
            }
        }
    }
    .donwnload_pop_warp {
        .van-popup{
            width: 5.6rem;
            border-radius: 0.1rem;
            overflow: hidden;
        }
        .donwnload_box {
            padding-top: 0.6rem;
            padding-bottom: 0.44rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            .down_img {
                width: 3.51rem;
                min-width: 3.51rem;
                width: 3.51rem;
                min-height: 2.31rem;
            }
            &>p {
                font-size: 0.32rem;
                text-align: center;
                color: #333;
                line-height: 0.48rem;
                margin: 0.4rem 0;
            }
            .btn {
                width: 4.8rem;
                color: #fff;
                background-color: #409EFF;
                font-size: 0.32rem;
                line-height: 0.7rem;
                text-align: center;
                border-radius: 0.35rem;
            }
        }
    }
    .btn_box {
        font-size: 0.32rem;
        width: 100vw;
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #409EFF;
        color: #FFF;
    }
    .disable_btn {
        background-color: #94C2F1;
    }
}
</style>